// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "mltraining/internalapi/v1/mltraining.proto" (package "mltraining.internalapi.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private ml training annotations RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { ModelType } from "../../../app/mltraining/v1/ml_training";
/**
 * @generated from protobuf message mltraining.internalapi.v1.SubmitHyperparameterTuningJobRequest
 */
export interface SubmitHyperparameterTuningJobRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: string registry_item_id = 2;
     */
    registryItemId: string;
    /**
     * @generated from protobuf field: string registry_item_version = 6;
     */
    registryItemVersion: string;
    /**
     * @generated from protobuf field: string organization_id = 3;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string model_name = 4;
     */
    modelName: string;
    /**
     * @generated from protobuf field: string model_version = 5;
     */
    modelVersion: string;
    /**
     * @generated from protobuf field: string container_version = 8;
     */
    containerVersion: string;
    /**
     * @generated from protobuf field: map<string, string> arguments = 7;
     */
    arguments: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.SubmitHyperparameterTuningJobResponse
 */
export interface SubmitHyperparameterTuningJobResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.GetModelMetricsForJobRequest
 */
export interface GetModelMetricsForJobRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.FloatList
 */
export interface FloatList {
    /**
     * @generated from protobuf field: repeated float values = 1;
     */
    values: number[];
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.GetModelMetricsForJobResponse
 */
export interface GetModelMetricsForJobResponse {
    /**
     * @generated from protobuf field: map<string, mltraining.internalapi.v1.FloatList> metrics = 1;
     */
    metrics: {
        [key: string]: FloatList;
    };
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.ValidateTrainingJobRequest
 */
export interface ValidateTrainingJobRequest {
    /**
     * @generated from protobuf field: string dataset_id = 1;
     */
    datasetId: string;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelType model_type = 2;
     */
    modelType: ModelType;
    /**
     * @generated from protobuf field: repeated string labels = 3;
     */
    labels: string[];
    /**
     * @generated from protobuf field: bool is_custom_job = 4;
     */
    isCustomJob: boolean;
    /**
     * @generated from protobuf field: map<string, int32> label_counts = 5;
     */
    labelCounts: {
        [key: string]: number;
    };
    /**
     * This map should be left empty for single-label classification models.
     *
     * @generated from protobuf field: int32 dataset_size = 6;
     */
    datasetSize: number;
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.ValidationError
 */
export interface ValidationError {
    /**
     * @generated from protobuf field: mltraining.internalapi.v1.ValidationErrorType error_type = 1;
     */
    errorType: ValidationErrorType;
    /**
     * @generated from protobuf field: repeated string affected_labels = 2;
     */
    affectedLabels: string[]; // Labels that don't meet requirements (for TOO_FEW_ANNOTATIONS)
    /**
     * @generated from protobuf field: int32 required_minimum_annotations_per_class = 3;
     */
    requiredMinimumAnnotationsPerClass: number; // Minimum required annotations per class (for TOO_FEW_ANNOTATIONS)
    /**
     * @generated from protobuf field: int32 required_minimum_dataset_size = 4;
     */
    requiredMinimumDatasetSize: number; // Minimum required dataset size (for DATASET_TOO_SMALL)
    /**
     * @generated from protobuf field: int32 additional_images_to_label = 5;
     */
    additionalImagesToLabel: number; // Additional images to label (for TOO_MANY_UNLABELED)
    /**
     * @generated from protobuf field: float labeled_percentage = 6;
     */
    labeledPercentage: number; // Percentage of labeled images (for TOO_MANY_UNLABELED)
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.ValidateTrainingJobResponse
 */
export interface ValidateTrainingJobResponse {
    /**
     * @generated from protobuf field: int32 multi_label_count = 1;
     */
    multiLabelCount: number; // Number of images with multiple labels (relevant for single-label classification)
    /**
     * @generated from protobuf field: repeated mltraining.internalapi.v1.ValidationError errors = 2;
     */
    errors: ValidationError[]; // Empty if validation passed
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.SetModelRetrainingScheduleRequest
 */
export interface SetModelRetrainingScheduleRequest {
    /**
     * @generated from protobuf field: string registry_item_id = 1;
     */
    registryItemId: string;
    /**
     * Standard 5-field cron expression. Empty string disables the schedule.
     *
     * @generated from protobuf field: string cron_expression = 2;
     */
    cronExpression: string;
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.SetModelRetrainingScheduleResponse
 */
export interface SetModelRetrainingScheduleResponse {
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.GetModelRetrainingScheduleRequest
 */
export interface GetModelRetrainingScheduleRequest {
    /**
     * @generated from protobuf field: string registry_item_id = 1;
     */
    registryItemId: string;
}
/**
 * @generated from protobuf message mltraining.internalapi.v1.GetModelRetrainingScheduleResponse
 */
export interface GetModelRetrainingScheduleResponse {
    /**
     * The current cron expression. Empty if no schedule is set.
     *
     * @generated from protobuf field: string cron_expression = 1;
     */
    cronExpression: string;
    /**
     * The last error encountered during retraining, if any. Empty if the last run succeeded or no run has occurred.
     *
     * @generated from protobuf field: string last_error = 2;
     */
    lastError: string;
}
/**
 * @generated from protobuf enum mltraining.internalapi.v1.JobType
 */
export enum JobType {
    /**
     * @generated from protobuf enum value: JOB_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: JOB_TYPE_VIAM_TRAINING = 1;
     */
    VIAM_TRAINING = 1,
    /**
     * @generated from protobuf enum value: JOB_TYPE_CUSTOM_TRAINING = 2;
     */
    CUSTOM_TRAINING = 2,
    /**
     * @generated from protobuf enum value: JOB_TYPE_HYPERPARAMETER_TUNING = 3;
     */
    HYPERPARAMETER_TUNING = 3
}
/**
 * @generated from protobuf enum mltraining.internalapi.v1.ValidationErrorType
 */
export enum ValidationErrorType {
    /**
     * @generated from protobuf enum value: VALIDATION_ERROR_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: VALIDATION_ERROR_TYPE_DATASET_TOO_SMALL = 1;
     */
    DATASET_TOO_SMALL = 1,
    /**
     * @generated from protobuf enum value: VALIDATION_ERROR_TYPE_TOO_FEW_ANNOTATIONS = 2;
     */
    TOO_FEW_ANNOTATIONS = 2,
    /**
     * @generated from protobuf enum value: VALIDATION_ERROR_TYPE_NO_MATCHING_ANNOTATIONS = 3;
     */
    NO_MATCHING_ANNOTATIONS = 3,
    /**
     * @generated from protobuf enum value: VALIDATION_ERROR_TYPE_TOO_MANY_UNLABELED = 4;
     */
    TOO_MANY_UNLABELED = 4,
    /**
     * @generated from protobuf enum value: VALIDATION_ERROR_TYPE_ALL_IMAGES_MULTI_LABELED = 5;
     */
    ALL_IMAGES_MULTI_LABELED = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class SubmitHyperparameterTuningJobRequest$Type extends MessageType<SubmitHyperparameterTuningJobRequest> {
    constructor() {
        super("mltraining.internalapi.v1.SubmitHyperparameterTuningJobRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "registry_item_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "model_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "model_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "container_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "arguments", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.SubmitHyperparameterTuningJobRequest
 */
export const SubmitHyperparameterTuningJobRequest = new SubmitHyperparameterTuningJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitHyperparameterTuningJobResponse$Type extends MessageType<SubmitHyperparameterTuningJobResponse> {
    constructor() {
        super("mltraining.internalapi.v1.SubmitHyperparameterTuningJobResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.SubmitHyperparameterTuningJobResponse
 */
export const SubmitHyperparameterTuningJobResponse = new SubmitHyperparameterTuningJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetModelMetricsForJobRequest$Type extends MessageType<GetModelMetricsForJobRequest> {
    constructor() {
        super("mltraining.internalapi.v1.GetModelMetricsForJobRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.GetModelMetricsForJobRequest
 */
export const GetModelMetricsForJobRequest = new GetModelMetricsForJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FloatList$Type extends MessageType<FloatList> {
    constructor() {
        super("mltraining.internalapi.v1.FloatList", [
            { no: 1, name: "values", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.FloatList
 */
export const FloatList = new FloatList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetModelMetricsForJobResponse$Type extends MessageType<GetModelMetricsForJobResponse> {
    constructor() {
        super("mltraining.internalapi.v1.GetModelMetricsForJobResponse", [
            { no: 1, name: "metrics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FloatList } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.GetModelMetricsForJobResponse
 */
export const GetModelMetricsForJobResponse = new GetModelMetricsForJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateTrainingJobRequest$Type extends MessageType<ValidateTrainingJobRequest> {
    constructor() {
        super("mltraining.internalapi.v1.ValidateTrainingJobRequest", [
            { no: 1, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_type", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelType", ModelType, "MODEL_TYPE_"] },
            { no: 3, name: "labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_custom_job", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "label_counts", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } },
            { no: 6, name: "dataset_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.ValidateTrainingJobRequest
 */
export const ValidateTrainingJobRequest = new ValidateTrainingJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidationError$Type extends MessageType<ValidationError> {
    constructor() {
        super("mltraining.internalapi.v1.ValidationError", [
            { no: 1, name: "error_type", kind: "enum", T: () => ["mltraining.internalapi.v1.ValidationErrorType", ValidationErrorType, "VALIDATION_ERROR_TYPE_"] },
            { no: 2, name: "affected_labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "required_minimum_annotations_per_class", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "required_minimum_dataset_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "additional_images_to_label", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "labeled_percentage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.ValidationError
 */
export const ValidationError = new ValidationError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateTrainingJobResponse$Type extends MessageType<ValidateTrainingJobResponse> {
    constructor() {
        super("mltraining.internalapi.v1.ValidateTrainingJobResponse", [
            { no: 1, name: "multi_label_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "errors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ValidationError }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.ValidateTrainingJobResponse
 */
export const ValidateTrainingJobResponse = new ValidateTrainingJobResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetModelRetrainingScheduleRequest$Type extends MessageType<SetModelRetrainingScheduleRequest> {
    constructor() {
        super("mltraining.internalapi.v1.SetModelRetrainingScheduleRequest", [
            { no: 1, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cron_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.SetModelRetrainingScheduleRequest
 */
export const SetModelRetrainingScheduleRequest = new SetModelRetrainingScheduleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetModelRetrainingScheduleResponse$Type extends MessageType<SetModelRetrainingScheduleResponse> {
    constructor() {
        super("mltraining.internalapi.v1.SetModelRetrainingScheduleResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.SetModelRetrainingScheduleResponse
 */
export const SetModelRetrainingScheduleResponse = new SetModelRetrainingScheduleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetModelRetrainingScheduleRequest$Type extends MessageType<GetModelRetrainingScheduleRequest> {
    constructor() {
        super("mltraining.internalapi.v1.GetModelRetrainingScheduleRequest", [
            { no: 1, name: "registry_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.GetModelRetrainingScheduleRequest
 */
export const GetModelRetrainingScheduleRequest = new GetModelRetrainingScheduleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetModelRetrainingScheduleResponse$Type extends MessageType<GetModelRetrainingScheduleResponse> {
    constructor() {
        super("mltraining.internalapi.v1.GetModelRetrainingScheduleResponse", [
            { no: 1, name: "cron_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message mltraining.internalapi.v1.GetModelRetrainingScheduleResponse
 */
export const GetModelRetrainingScheduleResponse = new GetModelRetrainingScheduleResponse$Type();
/**
 * @generated ServiceType for protobuf service mltraining.internalapi.v1.InternalMLTrainingService
 */
export const InternalMLTrainingService = new ServiceType("mltraining.internalapi.v1.InternalMLTrainingService", [
    { name: "SubmitHyperparameterTuningJob", options: {}, I: SubmitHyperparameterTuningJobRequest, O: SubmitHyperparameterTuningJobResponse },
    { name: "GetModelMetricsForJob", options: {}, I: GetModelMetricsForJobRequest, O: GetModelMetricsForJobResponse },
    { name: "ValidateTrainingJob", options: {}, I: ValidateTrainingJobRequest, O: ValidateTrainingJobResponse },
    { name: "SetModelRetrainingSchedule", options: {}, I: SetModelRetrainingScheduleRequest, O: SetModelRetrainingScheduleResponse },
    { name: "GetModelRetrainingSchedule", options: {}, I: GetModelRetrainingScheduleRequest, O: GetModelRetrainingScheduleResponse }
]);
